<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.9588C9.50005 18.9588 9.00838 18.8421 8.60838 18.6171L4.66672 16.3421C3.03338 15.2421 2.92505 15.0421 2.92505 13.3171V9.18379C2.92505 7.45879 3.03338 7.25879 4.63338 6.18379L8.61671 3.88379C9.40838 3.42546 10.6 3.42546 11.3917 3.88379L15.3334 6.15879C16.9667 7.25879 17.075 7.45879 17.075 9.18379V13.3171C17.075 15.0421 16.9667 15.2421 15.3667 16.3171L11.3834 18.6171C10.9917 18.8505 10.4917 18.9588 10 18.9588ZM10 4.79212C9.71671 4.79212 9.43338 4.85046 9.23338 4.96712L5.29172 7.24212C4.17505 8.00046 4.17505 8.00046 4.17505 9.18379V13.3171C4.17505 14.5005 4.17505 14.5005 5.33338 15.2838L9.24171 17.5338C9.64171 17.7671 10.3667 17.7671 10.7667 17.5338L14.7084 15.2588C15.825 14.5005 15.825 14.5005 15.825 13.3171V9.18379C15.825 8.00046 15.825 8.00046 14.6667 7.21712L10.7584 4.96712C10.5667 4.85046 10.2834 4.79212 10 4.79212Z"
      fill="#667085"
    />
    <path
      d="M14.5834 6.98366C14.2417 6.98366 13.9584 6.70033 13.9584 6.35866V4.16699C13.9584 2.85033 13.4001 2.29199 12.0834 2.29199H7.91675C6.60008 2.29199 6.04175 2.85033 6.04175 4.16699V6.30033C6.04175 6.64199 5.75841 6.92533 5.41675 6.92533C5.07508 6.92533 4.79175 6.65033 4.79175 6.30033V4.16699C4.79175 2.15033 5.90008 1.04199 7.91675 1.04199H12.0834C14.1001 1.04199 15.2084 2.15033 15.2084 4.16699V6.35866C15.2084 6.70033 14.9251 6.98366 14.5834 6.98366Z"
      fill="#667085"
    />
    <path
      d="M11.3584 14.6913C11.1834 14.6913 11 14.6579 10.8167 14.5829L10 14.2663L9.18337 14.5913C8.7417 14.7663 8.2917 14.7246 7.95837 14.4829C7.62504 14.2413 7.45004 13.8246 7.47504 13.3496L7.52503 12.4746L6.9667 11.7996C6.6667 11.4246 6.5667 10.9913 6.70004 10.5913C6.82504 10.1996 7.1667 9.89961 7.62503 9.78294L8.47504 9.56628L8.95004 8.82461C9.45837 8.02461 10.55 8.02461 11.0584 8.82461L11.5334 9.56628L12.3834 9.78294C12.8417 9.89961 13.1834 10.1996 13.3084 10.5913C13.4334 10.9829 13.3334 11.4246 13.0334 11.7913L12.475 12.4663L12.525 13.3413C12.55 13.8163 12.375 14.2246 12.0417 14.4746C11.8417 14.6163 11.6084 14.6913 11.3584 14.6913ZM7.93337 10.9996L8.4917 11.6746C8.68337 11.8996 8.7917 12.2579 8.77504 12.5496L8.72504 13.4246L9.5417 13.0996C9.8167 12.9913 10.1834 12.9913 10.4584 13.0996L11.275 13.4246L11.225 12.5496C11.2084 12.2579 11.3167 11.9079 11.5084 11.6746L12.0667 10.9996L11.2167 10.7829C10.9334 10.7079 10.6334 10.4913 10.475 10.2496L10.0084 9.51628L9.53337 10.2496C9.37504 10.4996 9.07504 10.7163 8.7917 10.7913L7.93337 10.9996Z"
      fill="#667085"
    />
  </svg>
</template>
  
<script>
export default {
  name: "AchievementsIcon",
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    isActive: Boolean,
  },
  data() {
    return {};
  },
};
</script>
